import { Box, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, VStack } from '@chakra-ui/react'


const EmailPreviewModal = ({ onEmailPreviewClose, isEmailPreviewOpen, subject, body }) => {
    return (
        <Modal isOpen={isEmailPreviewOpen} onClose={onEmailPreviewClose} size={"3xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Email Preview</ModalHeader>
                <ModalCloseButton />
                <ModalBody >
                    <VStack spacing={4} align="stretch" px={6}>
                        {subject && (
                            <Box>
                                <Text fontSize="md" fontWeight="semibold" color="gray.600" mb={1}>
                                    Subject:
                                </Text>
                                <Text fontSize="md" fontWeight="semi-bold" color="gray.800">
                                    {subject}
                                </Text>
                            </Box>
                        )}

                        <Box>
                            <Text fontSize="md" fontWeight="semibold" color="gray.600" mb={2}>
                                Content:
                            </Text>
                            <Box
                                p={4}
                                border="1px"
                                borderColor="gray.200"
                                borderRadius="md"
                                bg="white"
                                maxH="400px"
                                overflowY="auto"
                                dangerouslySetInnerHTML={{ __html: body }}
                            />
                        </Box>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm"
                        border={"1px solid #0000001a"}
                        color={"#0a0a0a"}
                        bg={"white"}
                        _hover={{
                            bg: "#e2e8f0 !important",
                            color: "black !important",
                        }} onClick={onEmailPreviewClose}>
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default EmailPreviewModal